// removed by extract-text-webpack-plugin
module.exports = {"orderlistcomponent":"_3idoXz7ybqMmvM-zGJuBzL","danlie":"tja3dPCChM5ghFxmBqyDb","danlieul":"_2IqtziCUiGgf6fh2etbIE7","active":"_1f9wIG07DHUIC7G4GiRl49","danlieshou":"_3uNh7WczYA4muDKA7eetNE","inp":"_24YXcPdXoPxZlaKOyTDtdw","linka":"_34gc0gwxLFJI2OFi3C1g5a","linkb":"_3su1Jzi5_Ut499K1AAeRoc","jiesuannpage":"_28emMzwJtjLMAIHTAx0Mhj","pagechildren":"_1Ho83Bhx2yhIV3J4OJIh-4","childa":"_3VFs7q4och4lA4thHFrtS","childb":"_1JgdHqybFOel96ch2BPHvK","pagelienew":"_3iRwl42Gu1NVCpavHwS_x-","lienewtop":"_1-vOuqJYhvWbsxA9ElHlme","newtoptxt":"DwSE52Wo1fKvjY_n_jWQ6","danliebtn":"_1Tt8UaQouMKLXHXc1dXIM_"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/GroupBuyingOrderList/GroupBuyingOrderList.scss
 ** module id = 1068
 ** module chunks = 0
 **/